import * as types from '../mutation-types';
import {unionState} from '../union-state'

const state = {
    equivalentMoneyAmount: {},
	currencies: []
};

const actions = {
	exchangeToCurrency({ commit }, { toCurrencyId, amount, fromCurrecyId,  }) {
		return window.axios.get(`Currencies/Exchange/ToCurrency/${toCurrencyId}`, { 
            params:{
				fromCurrecyId,
                amount
            } 
        }).then(response => {
            commit(types.STORE_EQUIVALENT_MONEY_AMOUNT, response.data)
            return response.data
		})
	},
	fetchAll({ commit }) {
		return window.axios.get('Currencies',
		).then(response => {
			commit(types.STORE_CURRENCIES, response.data)
		})
	},
	create(vuexContext, { name, symbol, latestExchangeRecord }) {
		return window.axios.post(`Currencies`, {
			name,
			symbol,
			latest_exchange_record: latestExchangeRecord
		}).then(response => response.data);
	},
	update(vuexContext, { id, name, symbol }) {
		return window.axios.put(`Currencies/${id}`, {
			id,
			name,
			symbol,
		})
		.then(response => response.data);
	},
	createExchangeRecord(vuexContext, { id, exchangeValue, createdAt }) {
		return window.axios.post(`Currencies/Exchange/${id}`, {
			id,
			to_currency_id: id,
			exchange_value: exchangeValue,
			created_at: createdAt
		}).then(response => response.data)
	},
	fetchExchangeRecords(vuexContext, currencyId) {
		return window.axios.get(`Currencies/Exchange/${currencyId}`).then(response => {
			return response.data;
		})
	},
	deleteCurrency(vuexContext, currencyId) {
		return window.axios.delete(`/Currencies/${currencyId}`)

	}
}

const mutations = {
	[types.STORE_EQUIVALENT_MONEY_AMOUNT](state, equivalentMoneyAmount) {
		state.equivalentMoneyAmount = equivalentMoneyAmount;
	},
	[types.STORE_CURRENCIES](state, currencies) {
		state.currencies = currencies;
	},
	[types.STORE_ONE_CURRENCY](state, currency) {
        state.currencies = unionState(state.currencies, [currency]);
	}
}

const getters = {
	getCurrencyById: state => id => state.currencies.find(c => c.id === id)
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}

